import * as T from "../utilities/frontendTypes";
import { Link, useLocation } from "react-router-dom"
import parseStringToHTML from "html-react-parser";
import { useState, useContext } from "react";
import { cn } from "@lib/utils";
import { SidebarContext, SidebarContextType } from "../utilities/customHooks";


export default function SideMenuNavButton({link, text, imgSrc, disabled, tooltipContent, activeImgSrc, isChild, forceActive}: T.MenuData & { isChild?: boolean; forceActive?: boolean }) {
  const [showTooltip, setShowTooltip] = useState(false);
  const { pathname } = useLocation();
  const sidebar = useContext(SidebarContext) as SidebarContextType;

  // Active state: exact match for /dashboard, prefix match for others
  const pathActive = link === '/dashboard'
    ? pathname === '/dashboard'
    : pathname === link || pathname.startsWith(link + '/');
  const isActive = forceActive || pathActive;

  return (
    <div
      className={cn(
        "flex transition-colors duration-150 relative group",
        disabled ? "cursor-not-allowed" : "hover:bg-black/5 rounded-lg",
        isChild
          ? isActive
            ? "rounded-lg bg-white/80 font-medium"
            : ""
          : isActive
            ? "rounded-lg bg-white font-semibold"
            : ""
      )}
      key={link}
      onMouseEnter={() => tooltipContent && disabled && setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <Link
        tabIndex={disabled ? -1 : 0}
        to={link}
        className={cn(
          "py-2 px-3 flex w-full items-center overflow-hidden",
          isChild && "py-1.5",
          disabled && 'pointer-events-none opacity-50'
        )}
        aria-disabled={disabled}
      >
        <div className={cn("flex items-center shrink-0", isChild && "scale-[0.85] origin-left")}>
          <span className={cn(isActive || "hidden", "group-hover:inline")}>
            {activeImgSrc && parseStringToHTML(activeImgSrc)}
          </span>
          <span className={cn(isActive && "hidden", "group-hover:hidden")}>
            {imgSrc && parseStringToHTML(imgSrc)}
          </span>
        </div>
        <p className={cn(
          "ml-2 sideMenuText whitespace-nowrap transition-opacity duration-300",
          sidebar?.isCollapsed ? "opacity-0 w-0" : "opacity-100",
          isChild && "text-xs"
        )}>{text}</p>
      </Link>
      {showTooltip && tooltipContent && (
        <div
          className="absolute px-3 py-2 bg-gray-800 text-white text-sm rounded whitespace-nowrap shadow-lg"
          style={{
            top: '50%',
            left: '100%',
            transform: 'translateY(-50%)',
            marginLeft: '8px',
            zIndex: 99999
          }}
        >
          {tooltipContent}
          <div
            style={{
              position: 'absolute',
              top: '50%',
              right: '100%',
              transform: 'translateY(-50%)',
              width: 0,
              height: 0,
              borderTop: '6px solid transparent',
              borderBottom: '6px solid transparent',
              borderRight: '6px solid #1f2937'
            }}
          ></div>
        </div>
      )}
    </div>
  )
}
